import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import QRCode from "react-qr-code";
import {getData} from '../services/index';
import {  QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined,UploadOutlined,MobileOutlined,FilterOutlined } from '@ant-design/icons';

import { Drawer,Popconfirm } from 'antd';

import DatePickers from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
 import axios from 'axios';

import $ from 'jquery';
const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			followup_date: new Date(),
			import_loading:false,
			csv_file:null,
			import_visible:false,
			msg: '',
			school_id: '',
			sms_text:'',
			email_subject:'',
			email_body:'',
			selection_count:0,
			sms_visible:false,
			email_visible:false,
			qr_visible:false,
			filter_visible:false,
			checkedBoxes: [],
			school_list : [],
			timeline_details : [],
			marketing_followup_details : [],
			enquiries_details : [],
			fees_setting : [],
			academic_year_ : [],
			index:0,
			visible: false,
			followup: false,
			addfollow: false,
			status_view: false,
			fees_view: false,
			timeline: false,
			checkAll: false,
			mobile_sms: false,
			mobile_follow: false,
			checkedList: defaultCheckedList,
			checked: false,
			enquiry_id:0,
			currentDate:'',
			source:'',
			academic_year:'',
			date:'',
			keyword:'',
			qr_link:'',
			follow_status:'',
			followup_status : [],
		}		
		this.importSubmit = this.importSubmit.bind(this);
		this.inputChange = this.inputChange.bind(this);	
		this.onChangechecked = this.onChangechecked.bind(this);
		this.handleQrSubmit = this.handleQrSubmit.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSubmitEnquiry = this.handleSubmitEnquiry.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.onChangebirthday = this.onChangebirthday.bind(this);	
		this.change_priorty = this.change_priorty.bind(this);	
		this.change_status = this.change_status.bind(this);	
		this.change_source = this.change_source.bind(this);	
		this.change_year = this.change_year.bind(this);	
		this.onChangedate = this.onChangedate.bind(this);	
		this.submit_search = this.submit_search.bind(this);	
		this.movetoenroll = this.movetoenroll.bind(this);	
	}
	
	movetoenroll = (id) => {
	  var link = '/enquiries_enroll/'+id;
	  window.location.href = link;
   }; 
	
	change_source(event){
         this.setState({source: event});
    }
	change_year(event){
         this.setState({academic_year: event});
     }
	 
	 onChangedate(date, dateString) {
	  this.setState({ date: dateString });
		;
	}
	
	submit_search(){
		
		this.setState({
            filter_visible: false,
        })
		setTimeout(() => {
			this.checkData();
		}, 500);
	}
	
	showImport = () =>  {
		this.setState({
			import_visible: true,
		});		
	}
	
	closeImport = () =>  {
		this.setState({
			import_visible: false,
		});		
	}
	
	showFilter = () =>  {
		this.setState({
			filter_visible: true,
		});		
	}
	
	closeFilter = () =>  {
		this.setState({
			filter_visible: false,
		});	
		window.location.reload(false);	
	}
	
	showQr = () =>  {
		this.setState({
			qr_visible: true,
		});		
	}
	
	closeQr = () =>  {
		this.setState({
			qr_visible: false,
		});		
	}
	
	showmobilesms = () =>  {
		this.setState({
			mobile_sms: true,
		});		
	}
	
	closemobilesms = () =>  {
		this.setState({
			mobile_sms: false,
		});		
	}
	
	showmobilefollow = () =>  {
		this.setState({
			mobile_follow: true,
		});		
	}
	
	closemobilefollow = () =>  {
		this.setState({
			mobile_follow: false,
		});		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id'] });
			
			var school_id = storedArray['data'][0]['school_id'];
			var mess = 'Thank you for visiting the school. Kindly fill the enquiry form !!! Url : https://school.kidzonia.co.in/enquiries_link_add/'+school_id;
			var qr_link = 'https://school.kidzonia.co.in/enquiries_link_add/'+school_id;
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'],msg:mess,qr_link:qr_link});
		
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			function formatDate(date) {
				var d = new Date(date),
					month = '' + (d.getMonth() + 1),
					day = '' + d.getDate(),
					year = d.getFullYear();
				if (month.length < 2) 
					month = '0' + month;
				if (day.length < 2) 
					day = '0' + day;
				return [year, month, day].join('-');
			}
			var currentDate=formatDate(date);
			this.setState({ currentDate : currentDate });
		}
		this.checkData();
		
		
		$(document).ready(function(e){
	 $(".check_enq").change(function(){
		  
		  alert('hi');
	  }); 
	      });	
		
	}
	
	downloadSample() {
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var id = storedArray['data'][0]['school_id'];
		setTimeout(() => {
			const response = {
			file: 'https://kcisapi.kidzonia.co.in/v1/Phpspreadsheet/sample_admission_enquiry/'+id,
			};
			message.config({ top: 150});
			message.success('File Downloaded',2);	
			window.open(response.file);
		}, 100);
	}
	
	importSubmit=(e)=>{
		
		e.preventDefault();		
		this.setState({ import_loading : true });
		if(this.state.csv_file==null){
			document.getElementById("upload_csv_label").classList.add("error_focus");
			this.setState({ import_loading : false });
			message.config({ top: 150});
			message.error('Please Select File !!',2);
		}
		else{
			if(localStorage.getItem('schoolData')){
				var storedArray = JSON.parse(localStorage.getItem("schoolData"));
				var user_id = storedArray['data'][0]['user_id'];
				var school_id = storedArray['data'][0]['school_id'];
				
				const data = new FormData() 
				data.append('fileURL', this.state.csv_file)
				data.append('user_id', user_id)
				data.append('school_id', school_id)
				let url = "https://kcisapi.kidzonia.co.in/v1/Phpspreadsheet/upload_admision_enquiry";
				axios.post(url, data, {
				})
				.then(res => {
					message.config({ top: 150});
					message.success('File Uploaded',2);	
					setTimeout(() => {
						this.setState({ import_loading : false });
						window.location.reload(false);	
					}, 1000);
					
					
				})
			}
		}
		
	} 


	
	import_file = (e) => {	
		console.log(e.target.files[0].name);
		document.getElementById("upload_csv_label").innerHTML=e.target.files[0].name;
		document.getElementById("upload_csv_label").classList.remove("error_focus");
		this.setState({ csv_file: e.target.files[0]});
    }
	
	inputChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	}
	
	Export = () => {
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,}
			getData('Phpspreadsheet/export_all_highschool_enquiries',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					message.config({ top: 150});
					message.success('File Downloaded',2);	
					window.open(responseJson.file_link);
				}
			});
		}
	}
	
	
	sendSMS = () => {
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,sms_text:this.state.sms_text}
			getData('highschool/send_sms_to_selected_id',app).then((result) => {
				let responseJson = result;
					if(result['status'] == 200){
						message.config({ top: 150});
						message.success('SMS Sent',2);
						setTimeout(() => {
							this.setState({
								sms_visible: false,
							})
						}, 1200);
						
					}else{
						
					}
				
			});
		}
	}
	
	sendEmail= () =>{
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id,selected_id:this.state.checkedBoxes,email_subject:this.state.email_subject,email_body:this.state.email_body}
			getData('highschool/send_email_to_selected_id',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						message.config({ top: 150});
						message.success('SMS Sent',2);
						setTimeout(() => {
							this.setState({
								sms_visible: false,
							})
						}, 1200);
						
					}else{
						
					}
				}
			});
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			
			var app = {user_id : user_id,school_id:school_id}
			var app_ = {
				user_id : user_id,
				school_id:school_id,
				source:this.state.source,
				academic_year:this.state.academic_year,
				date:this.state.date,
				keyword:this.state.keyword,
				}
			getData('erp/missed_followup_enquiries_list',app_).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
			getData('highschool/manage_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
						});
					}else{
						this.setState({
							academic_year_: [],
							
						});
					}
				}
			});	
			getData('common/get_followup_status',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
						this.setState({
							followup_status: result['data'],
						});	
				}else{
					this.setState({
						followup_status: [],
						
					});
				}
				}
			});
	}
	}
	
	change_followup_status(event){
         this.setState({follow_status: event});
    }
  
	showMenu= (id, e) =>  {
		e.preventDefault();
		if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
			document.getElementById('open_action_1_' + id).classList.remove('is-active');
			this.setState({
			  showMenu: 0,
			});
		}else{
			document.getElementById('open_action_' + id).classList.add('is-active');
			document.getElementById('open_action_1_' + id).classList.add('is-active');
			this.setState({
			  showMenu: 1,
			});
		}
		
		
	}

		
	 
	deletedata = (id) => {
		if(this.state.checkedBoxes.length>0){
			var app = {user_id : this.state.user_id,id:this.state.checkedBoxes,school_id:this.state.school_id}
			getData('erp/enquiry_delete',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){
						this.setState({
							marketing_delete: result['data'],
						});
						this.checkData();
						message.config({ top: 150});
						message.success('Selected enquiries deleted',2);
					}else{
						this.setState({
							marketing_delete: [],
						});
					}
				}
			});
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}; 
  
  movetoprinciple = (id,a) => {
	
	var app = {user_id : this.state.user_id,id:id,school_id:this.state.school_id}
			getData('erp/enquiry_move_principle_approval',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							marketing_delete: result['data'],
						});
						message.config({ top: 150});
						message.success('Enquiry Move To Admission',2);
					}else{
						this.setState({
							marketing_delete: [],
							
						});
					}
				}
			});
	window.location.reload(false);
	
  }; 
  
	showSMS = () => {		
		if(this.state.checkedBoxes.length>0){
			this.setState({
				sms_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}

	handleSMSOk = e => {
		this.setState({
			sms_visible: false,
		})
	}

	handleSMSCancel = e => {
		this.setState({
			sms_visible: false,
		})
	}
	
	showEmail = () => {
		if(this.state.checkedBoxes.length>0){
			this.setState({
				email_visible: true,
			})
		}
		else{
			message.config({ top: 150});
			message.error('Please select enquiries',2);
		}
	}

	handleEmailOk = e => {
		this.setState({
			email_visible: false,
		})
	}

	handleEmailCancel = e => {
		this.setState({
			email_visible: false,
		})
	}
  
  showModalfollowup = (id) => {
    this.setState({
      followup: true,
	  enquiry_id:id
    });
	//document.getElementById('open_action_' + id).classList.remove('is-active');
	var app = {user_id : this.state.user_id,enquiry_id:id}
		getData('erp/enquiry_followup_details',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						marketing_followup_details: result['data'],
					});
				}else{
					this.setState({
						marketing_followup_details: [],
					});
				}
			}
		});
	};

  handleOkfollowup = e => {
    console.log(e);
    this.setState({
      followup: false,
    });
  };

  handleCancelfollowup = e => {
    console.log(e);
    this.setState({
      followup: false,
    });
  };
  
  showModaltimeline = (id) => {
    this.setState({
	  enquiry_id:id,
      timeline: true,
    });
	
	var app = {user_id : this.state.user_id,id:id}
			getData('erp/enquiry_timeline_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							timeline_details: result['data'],
						});
					}else{
						this.setState({
							timeline_details: [],
							
						});
					}
				}
			});
  };

  handleOktimeline = e => {
    console.log(e);
    this.setState({
      timeline: false,
      addfollow: false,
    });
  };

  handleCanceltimeline = e => {
    console.log(e);
    this.setState({
      timeline: false,
      addfollow: false,
    });
  };
  
  addfollowModal = (id) => {  
    this.setState({
      addfollow: true
    });
  };

  addfollowOk = e => {
    console.log(e);
    this.setState({
      addfollow: false,
    });
  };

  addfollowCancel = e => {
    console.log(e);
    this.setState({
      addfollow: false,
    });
  };
  
  
 statusModal = () => {
    this.setState({
      status_view: true,
    });
  };

  statusOk = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };

  statusCancel = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };

  
	handleQrSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		var app = {
			
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			msg : this.state.msg,
			number : this.state.number
		}
		getData('erp/send_enquiry_link',app).then((result) => {
		if(result.status==400){
             message.config({ top: 150});
			message.error(result.message,2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Message Sent Successfull',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
             window.location.reload(false);

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }
  
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				user_id: this.state.user_id,
				enquiry_id: this.state.enquiry_id,
				status: this.state.follow_status,
				remark: this.state.remark,
				followup_date: this.state.followup_date,
				priority: this.state.priority 
			}
			getData('erp/add_enquiry_followup',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					
					message.config({ top: 150});
					message.success('Followup added',2);
					this.setState({ loading: false,addfollow: false,timeline: false, });
					this.checkData();
					this.getTimeline(this.state.enquiry_id);
				}
			})
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
	getTimeline= (id) => {
		var app = {user_id : this.state.user_id,id:id}
		getData('erp/enquiry_timeline_details',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						timeline_details: result['data'],
					});
				}else{
					this.setState({
						timeline_details: [],
						
					});
				}
			}
		});
	}
  
	onChangechecked(checkedValues) {
		this.setState({ checked_id: this.state.checked_id.concat(checkedValues) });
	}	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		
	};
	
	onChangebirthday(date, dateString) {
	 this.setState({ followup_date: dateString });
	}
	
	change_priorty(event){
         this.setState({priority: event});
    }
	
	change_status(event){
         this.setState({
						status: event,
						status_view: true,
						});
		if(event === 'Pending'){
			this.setState({
						status_title: 'Are you sure to change status to pending ?',
						});
		}				
		if(event === 'Confirm'){
			this.setState({
						status_title: 'Are you sure to confirm the admission?',
						});
		}	
		if(event === 'Reject'){
			this.setState({
						status_title: 'Are you sure to reject?',
						});
		}
		if(event === 'Cancle'){
			this.setState({
						status_title: 'Are you sure to cancel?',
						});
		}		
     }
	 
  statusModal = () => {
    this.setState({
      status_view: true,
    });
  };

  statusOk = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };

  statusCancel = e => {
    console.log(e);
    this.setState({
      status_view: false,
    });
  };
  
  feesModal = (id) => {
   //document.getElementById('open_action_' + id).classList.remove('is-active');
   
    this.setState({
      fees_view: true,
	  extra_fees_id : id,
    });
	var app = {user_id : this.state.user_id,id:id}
			getData('highschool/enquiries_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							enquiries_details: result['data'],
						});
						
						
					}else{
						this.setState({
							enquiries_details: [],
						});
					}
				}
			});
			getData('highschool/manage_pre_admission_fees_setting',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							fees_setting: result['data'],
							index: id,
						});
						
						
					}else{
						this.setState({
							fees_setting: [],
							index: 0,
						});
					}
				}
			});
  };

  feesOk = e => {
    console.log(e);
    this.setState({
      fees_view: false,
    });
  };

  feesCancel = e => {
    console.log(e);
    this.setState({
      fees_view: false,
    });
  };
  
  onChange = e => {
    console.log('checked = ', e.target.checked);
    this.setState({
      checked: e.target.checked,
    });
  };
  

  
 calculateDiscountAmt (listPrice, discount){
  listPrice = parseFloat(listPrice);
  discount  = parseFloat(discount);
  return (( listPrice * discount / 100 )).toFixed(2);
}
 calculateDiscountPer(listPrice, salePrice){
  listPrice = parseFloat(listPrice);
  salePrice = parseFloat(salePrice);
  return  (salePrice * 100 / listPrice).toFixed(2);
}
  
   
  
  
   discount_check = (i,index,e) => { 
		//console.log(e.target.value);
	
		var discount_amt=e.target.value
		var due_amount=$('#due_amount_'+this.state.extra_fees_id+'_'+i+'_'+index).val();
		
		if(Number(discount_amt)>Number(due_amount)){
		 message.config({ top: 150});
         message.error('Discount cant not be greater than Due Amount!',2);
		 $("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		}
		else{		
		var cal_discount_per=this.calculateDiscountPer(due_amount,discount_amt);	
		//alert(cal_discount_per);
		
		$("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val(cal_discount_per);
		var payable_amt=parseFloat(due_amount)-parseFloat(discount_amt);
		$("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val(payable_amt);		
		}
   }  
   
   discount_per_check = (i,index,e) => { 
		//console.log(e.target.value);
		
		var discount_per=e.target.value
		if(Number(discount_per)>100){
		 message.config({ top: 150});
         message.error('Discount Percentage cant not be greater than 100!',2);
		 $("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		 $("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
		}
		else{		
		var due_amount=$('#due_amount_'+this.state.extra_fees_id+'_'+i+'_'+index).val();
		var cal_discount_amount=this.calculateDiscountAmt(due_amount,discount_per);		
		 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val(cal_discount_amount);
		 var payable_amt=parseFloat(due_amount)-parseFloat(cal_discount_amount);
		 $("#payable_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val(payable_amt);	
		 }
   }
   
    payable_amt_check = (i,index,e) => { 				
	 $("#discount_per_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');	
	 $("#discount_amt_"+this.state.extra_fees_id+'_'+i+'_'+index).val('');			
   }
   

   
   
  handleSubmitEnquiry=(index,e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		const enquiry_length = this.state.fees_setting.length;

		for (var i = 0; i < enquiry_length; i++) {
			var due_amount=$('#due_amount_'+this.state.extra_fees_id+'_'+i+'_'+index).val();	
			var payable_amt=$('#payable_amt_'+this.state.extra_fees_id+'_'+i+'_'+index).val();
			var enquiry_date=$('#enquiry_date_'+this.state.extra_fees_id+'_'+i+'_'+index).val();
		
			if(Number(payable_amt)>Number(due_amount)){
				message.config({ top: 150});
				message.error('Please enter proper payable amount!!',2);
				this.setState({ loading: false });
				return false;
			}
			else if(payable_amt!=''){
				if(enquiry_date==''){
					message.config({ top: 150});
					message.error('Please enter proper date!!',2);
					this.setState({ loading: false });
					return false;
			  
				}	
			}
		}

        var fees_amount = [];
		for (var i = 0; i < enquiry_length; i++) {
			fees_amount[i]=document.getElementById('fees_amount_'+this.state.extra_fees_id+'_'+i+'_'+index).value; 			
		}
		  
	    var fees_id = [];
			for (var i = 0; i < enquiry_length; i++) {
			 fees_id[i]= document.getElementById('fees_id_'+this.state.extra_fees_id+'_'+i+'_'+index).value; 
		  }
		var discount_per = [];
		for (var i = 0; i < enquiry_length; i++) {
			discount_per[i]= document.getElementById('discount_per_'+this.state.extra_fees_id+'_'+i+'_'+index).value; 			
		}
        var discount_amt = [];
		for (var i = 0; i < enquiry_length; i++) {
			discount_amt[i]= document.getElementById('discount_amt_'+this.state.extra_fees_id+'_'+i+'_'+index).value; 
		}
		
		var payable_amt= [];
		var payable_am_input;
		for (var i = 0; i < enquiry_length; i++) {
			payable_amt[i]= document.getElementById('payable_amt_'+this.state.extra_fees_id+'_'+i+'_'+index).value;
		}
		var enquiry_date = [];
		var enquiry_date_input;
		for (var i = 0; i < enquiry_length; i++) {
			enquiry_date[i] = document.getElementById('enquiry_date_'+this.state.extra_fees_id+'_'+i+'_'+index).value; 
		}
		
		if (payable_amt.length===0) {
		         message.config({ top: 150});
				 message.error('Please enter alteast one details!!',2);
				 this.setState({ loading: false });
				 return false;
		}
		
		
		var	enquiry_id= this.state.extra_fees_id; 
		
		this.setState({ 
			enquiry_id: enquiry_id,
			fees_amount: fees_amount,
			fees_id: fees_id,
			discount_per: discount_per,
			discount_amt: discount_amt,
			payable_amt: payable_amt,
			enquiry_date: enquiry_date,
		});
				
		var app = {
			user_id: this.state.user_id ,
			school_id: this.state.school_id ,
			fees_amount: fees_amount,
			fees_id: fees_id,
			enquiry_id: enquiry_id,
			discount_per: discount_per,
			discount_amt: discount_amt,
			payable_amt: payable_amt,
			enquiry_date: enquiry_date,
		}
      getData('highschool/add_enquiries_payment',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error(result.message,2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Enquire Payment added',2);
            this.setState({ loading: false, });
			this.checkData();			
			    window.location.reload(false);			
          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }  
   
    toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true});
    }
	
	toggleUnChecked = () => {
		this.setState({checkedBoxes:[],checked:false});
    }
  
  handleCheckbox = (e, s) => {
    const checkedBoxes = [...this.state.checkedBoxes];
    if(e.target.checked) {
		checkedBoxes.push(s)
    } else {
		const index = checkedBoxes.findIndex((ch) => ch === s);
		checkedBoxes.splice(index, 1);
    }
    this.setState({checkedBoxes,selection_count:checkedBoxes.length});
  }
  
	handleDateChange = date => {
		this.setState({
			followup_date: date
		});
	};
   

	render() {
	
	var lenght = this.state.school_list.length; 
	var followup_lenght = this.state.marketing_followup_details.length; 
	

		return (
				<>
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Missed Followup
									<Link to={`${process.env.PUBLIC_URL}/enquiries_add`} className="btn btn-outline-primary btn-rounded alignToTitle"><i class="mdi mdi-plus"></i> Add 
									</Link>
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Missed Followup </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="card-body">
						<ul class="nav nav-tabs nav-tabs-solid">
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/enquiries/leads`} class="nav-link ">Leads</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/enquiries`} class="nav-link ">Enquiries</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/internal-enquiries`} class="nav-link ">Internal Enquiries</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/today-reminder`} class="nav-link ">Today's Followup Reminder</Link></li>
							<li class="nav-item " ><Link to={`${process.env.PUBLIC_URL}/missed-followup`} class="nav-link active">Missed Followup</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/today-followup`} class="nav-link">Today's Followup</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/move-to-admission`} class="nav-link">Move To Process Admission</Link></li>
						</ul>
					</div>
				</div>
				<div class="row">
                  <div class="col-sm-4 col-12"></div>
                  <div class="col-sm-8 col-12 text-right add-btn-col">
					
					<button className="btn btn-primary new-btn mr-1" onClick={this.Export}><DownloadOutlined />Export</button>
					<button className="btn btn-primary new-btn mr-1" onClick={this.showImport}><UploadOutlined /> Import</button>
	
					<button onClick={this.showQr} className="btn btn-primary new-btn mr-1"><QrcodeOutlined /> QR Code</button>
					
					<Popconfirm
							title="Are you sure delete?"
							onConfirm={this.deletedata}
							okText="Yes"
							cancelText="No"
						  >
							<button className="btn btn-primary new-btn mr-1" on><DeleteOutlined /> Delete</button>
				   </Popconfirm>
							 
					 
					 
					 
                  </div>
               </div>
               <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3">
					 <div class="card">
						<div class="card-body">
						<h4 class="mb-3 header-title">Missed Followup</h4>
                        <div class="table-responsive">
                           <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
                                    <th>#</th>
                                    <th>Child Name</th>
                                    <th>Class</th>
									<th>Date of Enquiry</th>
									<th>Followup Date</th>
									<th>Priority</th>
									<th>Source</th>
									<th>Status</th>
									<th>Added By</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>
							  {this.state.school_list.length == 0 && (<><tr><td colspan="10" class="text-center">No Enquiry Found</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
                                 <tr>
									<td>{index+1}</td>
                                    <td>{list.name}
									<span class="d-block">{list.primary_mobile}</span>
									</td>
									<td>{list.class_name}</td>
                                    <td>{list.date_of_enquiry}</td>
                                    <td>{list.followup_date}</td>
                                    <td>
									{(() => {
										if (list.priority=='Potential') {
											return (
												<>
													<div class="chip chip-green">
														<div class="chip-body">
															<span class="chip-text">Potential</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.priority=='Needs Follow up'){
											return (
												<>
													<div class="chip chip-blue">
														<div class="chip-body">
															<span class="chip-text">Needs Follow up</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.priority=='Tentative'){
											return (
												<>
													<div class="chip chip-orange">
														<div class="chip-body">
															<span class="chip-text">Tentative</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.priority=='Might Turn Up'){
											return (
												<>
													<div class="chip chip-red">
														<div class="chip-body">
															<span class="chip-text">Might Turn Up</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.priority=='Cold Lead'){
											return (
												<>
													<div class="chip chip-red">
														<div class="chip-body">
															<span class="chip-text">Cold Lead</span>
														</div>
													</div>
												</>
											)
										}else{
											return (
												<>
													{list.priority}
												</>
											)
										}
									})()}
									</td>
									<td>{list.how_know}</td>
									<td>
									{(() => {
										if (list.assign_label=='Admitted') {
											return (
												<>
													<div class="chip chip-green">
														<div class="chip-body">
															<span class="chip-text">Admitted</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.assign_label=='Lost'){
											return (
												<>
													<div class="chip chip-red">
														<div class="chip-body">
															<span class="chip-text">Lost</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.assign_label=='On Hold'){
											return (
												<>
													<div class="chip chip-orange">
														<div class="chip-body">
															<span class="chip-text">On Hold</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.assign_label=='Open'){
											return (
												<>
													<div class="chip chip-green">
														<div class="chip-body">
															<span class="chip-text">Open</span>
														</div>
													</div>
												</>
											)
										}
										else if(list.assign_label=='Other'){
											return (
												<>
													<div class="chip chip-blue">
														<div class="chip-body">
															<span class="chip-text">Other</span>
														</div>
													</div>
												</>
											)
										}
										else{
											return (
												<>
													{list.assign_label}
												</>
											)
										}
									})()}
									</td>
									<td>{list.added_by}</td>
                                    <td>
										<div class="dropright dropright">
											<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<i class="mdi mdi-dots-vertical"></i>
											</button>
											<ul class="dropdown-menu">
												<li> 
													<a href="javascript:void(0)" class="dropdown-item"  onClick={this.showModaltimeline.bind(this,list.id)}><i class="ri-history-line"></i>&nbsp; Timeline</a>
												</li>
												<li>
													<Link class="dropdown-item" to={`${process.env.PUBLIC_URL}/enquiries_edit/${list.id}`}>
														<i class="ri-edit-line"></i>&nbsp; View & Edit
													</Link>
												</li>
												<li> 
													<a href="javascript:void(0)" class="dropdown-item"  onClick={this.movetoenroll.bind(this,list.id)}><i class="ri-wallet-line"></i>&nbsp;  Enroll To Process Admission</a>
												</li>
											</ul>
										</div>
                                    </td>
                                 </tr>
								 ))}
                                
                              </tbody>
                           </table>
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   
			   <Drawer
				title="Timeline"
				placement="right"
				width={400}
				closable={true}
				onClose={this.handleCanceltimeline}
				visible={this.state.timeline}
				className="mobile-drawer"
			>
				<div class="followup-model timelines">
					{this.state.timeline_details.map((list) => (	
					<Timeline.Item color="blue">
						<p class="font-blue">{list.added_date}</p>
						<div class="card-content row no-margin">
								<div class="children bg-blue timeline communication iq-card2">
									<Collapse
										bordered={false}
									  >
										<Panel header={list.title} key={list.id}>
											{(() => {  
										if (list.type =='log') {
										return (
											<>
											</>
												)
												}
												else{
													return (
		<table>
		<tr><td><b>Remark  </b></td><td>{list.remark}</td></tr>
		<tr><td><b>Priority  </b></td><td>{list.priority}</td></tr>
		<tr><td><b>Followup Date  </b></td><td>{list.followup_date}</td></tr>
		</table>
												)
												}
											})()}
										</Panel>
										
									  </Collapse>
								</div>
						</div>
					</Timeline.Item >
					))}
					<div class="add_followup">
						<button className="btn btn-primary" onClick={this.addfollowModal.bind(this,this.state.enquiry_id)}><i class="ri-add-fill"></i> Add Followup</button>
					</div>
				</div>
			</Drawer>

			
			<Drawer
				title="QR Code"
				placement="right"
				width={400}
				closable={true}
				onClose={this.closeQr}
				visible={this.state.qr_visible}
				className="mobile-drawer"
			>
				<div class="qr form-group">
				 <div class="col m6 s12 no-padd">
							<h6 class=""><b>Send SMS to Parents to fill Enquiry form via link</b></h6>
							
							<div class="col col-md-12 center mt-10 view-Profile no-padd">
								<TextArea
											  id="story"	
											  placeholder={this.state.msg}
											  value={this.state.msg}
											  autoSize={{ minRows: 4, maxRows: 6 }}
											  className="mb-2"
											  onChange={this.handleSizeChange}
											  name="msg"
											  
											/>
								<input type="text" class="form-control" class="mb-2" name="number" placeholder="Enter Mobile Number" onChange={this.handleSizeChange}/>
								<div class="col m4 s12 mb-2 no-padd mt-2 text-center">						
									<Button type="button" onClick={this.handleQrSubmit} className="btn btn-primary mr-2">
										Submit
									</Button>
									<Button onClick={this.closeQr} type="button" className="btn btn-primary new-btn ">
										Back
									</Button>
								</div>
							</div>
						</div>	
						 <div class="col m6 s12 no-padd mt-30 text-center">
							<h6 class=""><b>Click on the below link or scan the QR code to open your school's Enquiry form</b></h6>
							<Link  to={`${process.env.PUBLIC_URL}/enquiries_link_add/${this.state.school_id}`}><h6 class="click_here"><b> Click Here !!</b></h6></Link>
							<QRCode
								id={this.state.qr_link}
								value={this.state.qr_link}
								size={100}
								level={"H"}
								includeMargin={true}
							  />
							 
						</div>	
				</div>
			</Drawer>
			
			
			<Drawer
				title="Filter"
				placement="left"
				width={400}
				closable={true}
				onClose={this.closeFilter}
				visible={this.state.filter_visible}
				className="mobile-drawer Profile-view"
			>
			<div class="filter fees">
				<div class="col m4 s12 mb-20 no-padd">
						<label>Source</label>
						<Select class="form-control" placeholder="Select Source" mode="multiple" allowClear onChange={this.change_source}>
							<Select.Option value="Digital Ads">Digital Ads</Select.Option>
							<Select.Option value="Facebook">Facebook</Select.Option>
							<Select.Option value="Flayers">Flayers</Select.Option>
							<Select.Option value="Perent referral">Perent referral</Select.Option>
							<Select.Option value="Poster Ads">Poster Ads</Select.Option>
							<Select.Option value="Staff referral">Staff referral</Select.Option>
							<Select.Option value="Walk In">Walk In</Select.Option>
							<Select.Option value="Website">Website</Select.Option>
						</Select>
						
					</div>
					<div class="col m4 s12 mb-20 no-padd">
						<label>Year</label>
						<Select onChange={this.change_year}>
										{this.state.academic_year_.map((list) => (
											<Select.Option value={list.id}>{list.academic_year}</Select.Option>
										))}
									</Select>
					</div>
					<div class="col m4 s12 mb-20 no-padd">
						<label>Date Of Collection</label>
						<DatePicker onChange={this.onChangedate} />
					</div>
					<div class="col m4 s12 mb-20 no-padd">
						<label>Search Keyword</label>
						<input type="text" class="form-control" name="keyword" onChange={this.handleSizeChange} />
					</div>
					<div class="col m4 s12 mb-20 no-padd">						
						<button type="button" class="primary-btn right ml-1" onClick={this.submit_search}>
							Submit
						</button>
						<button onClick={this.closeFilter} type="button" class="cancel-btn right ml-1">
							Cancel
						</button>
					</div>
				</div>
			</Drawer>
			
			
			
			<Modal
				 title="Import Enquiries"
				 visible={this.state.import_visible}
				 className="send-sms"
				 onCancel={this.closeImport}
				>					
					<div class="col col-md-12 s12 no-padd form-group">
						<label for="basicInputFile">Select File</label>
						<div class="custom-file">
							<input type="file" onChange={this.import_file.bind(this)} class="custom-file-input" id="upload_csv"/>
							<label class="custom-file-label" for="upload_csv" id="upload_csv_label"></label>
						</div>
					</div>
					<div class="col col-md-12 s12 center mt-20 mb-20 no-padd form-group">
						<button className="btn btn-primary new-btn" onClick={this.downloadSample}><DownloadOutlined /> Download Sample File</button>
						
						{(() => {  
							if (this.state.import_loading==true) {
								return (
									<>
										<Button className="btn btn-primary new-btn mr-3" loading>
											Import Now
										</Button>
									</>
								)
							}
							else{
								return (
									<>										
										<button className="btn btn-primary new-btn float-right" onClick={this.importSubmit.bind(this)}><UploadOutlined /> Import Now</button>
									</>
								)
							}
						})()}
					</div>
				</Modal>
			
			
				
				
				
				<Modal
					title="Follow Up"
					visible={this.state.followup}
					className="followup-model "
					onOk={this.handleOkfollowup}
					onCancel={this.handleCancelfollowup}
				>
				<div class="col col-md-12 s12">											
					{(() => {  
						if (followup_lenght =='0') {
						return (
									<h3 class="center">No Followup Found !!</h3>
								)
							}
					})()}
					 <Timeline>
					 {this.state.marketing_followup_details.map((list) => (	
						<Timeline.Item color="blue">
							<p class="font-blue">{list.added_date}</p>
							<div class="card-content border row no-margin">
								<div class="col col-md-12 s12 pt-10 pb-10">
									<p><b>Remark : </b>{list.remark}</p>
									<p><b>Follow Up Date : </b>{list.followup_date}</p>
									<p><b>Priority By : </b>{list.priority}</p>
									<p><b>Attended By : </b>{list.user_name}</p>
								</div> 
							</div>
						</Timeline.Item >
						))}
					  </Timeline>
					  
					  
				</div>	
				</Modal>
				
				<Modal
				 title="Add Follow Up"
				 visible={this.state.addfollow}
				 className="followup-model view-Profile"
				 onOk={this.addfollowOk}
				 onCancel={this.addfollowCancel}
				>
				<div class="col m6 s12 mt-10 form-group">
					<label>Status </label>
					<Select onChange={this.change_followup_status} defaultValue="Select Status">
						<Select.Option value="Potential">Select Status</Select.Option>
						{this.state.followup_status.map((fol) => (
						<Select.Option value={fol.name}>{fol.name}</Select.Option>
						))}
					</Select>
				</div>
				<div class="col col-md-12 s12 form-group">
					<input type="hidden" class="form-control" name="enquiry_id" id="enquiry_id" value={this.state.enquiry_id}/>
					<label>Remark</label>
					<TextArea
						placeholder="Your Text Goes Here !!"
						class="form-control"
						autoSize={{ minRows: 6, maxRows: 6 }}
						className=""
						onChange={this.handleSizeChange}
						name="remark"
						value={this.state.remark}
					/>
				</div>	
				<div class="col m6 s12 mt-10 datetime_picker form-group">
					<label>Follow Up Date</label>
					<DatePickers
						selected={this.state.followup_date}
						onChange={this.handleDateChange}
						minDate={new Date()}
						showTimeSelect
						timeIntervals={15}
						timeCaption="Time"
						dateFormat="MMMM d, yyyy h:mm aa"
					/>
				</div>
				<div class="col m6 s12 mt-10 form-group">
					<label>Priority </label>
					<Select onChange={this.change_priorty}>
						<Select.Option value="Potential">Potential</Select.Option>
						<Select.Option value="Needs Follow up">Needs Follow up</Select.Option>
						<Select.Option value="Tentative ">Tentative </Select.Option>
						<Select.Option value="Might Turn Up">Might Turn Up</Select.Option>
						<Select.Option value="Cold Lead">Cold Lead</Select.Option>
					</Select>
				</div>
				
				<div class="col col-md-12 s12 text-center mt-20">
					<Button className="btn btn-primary" onClick={this.handleSubmit} loading={this.state.loading}>Add</Button>
				</div>
				</Modal>	
				
			<Modal
				 title="Fess"
				 visible={this.state.fees_view}
				 className="followup-model view-Profile fees-model"
				 onOk={this.feesOk}
				 onCancel={this.feesCancel} 
				 width={1200}
				>
					{this.state.enquiries_details.map((list) => (	
					<div>
					<p><b>Name Of Student : {list.child_name}</b></p>
					
					<input type="hidden" name="id" id="id" value={list.id}/>
					<input type="hidden" name="enquiry_id" id="enquiry_id" value={list.id}/>
					<table class="table table-bordered table-hover dataTable  mb-0" id="fees_table">
						<thead>
							<tr>
							  <th class="txt-left mw-150">Category</th>
							  <th>Amount</th>
							  <th>Paid Amount</th>												  
							  <th>Due Amount</th>
							  <th>Discount (%)</th>
							  <th>Discount (Amount)</th>
							  <th>To be Paid</th>
							  <th>Date</th>
							</tr>
						</thead>
						<tbody>										
							{
							this.state.fees_setting.map((fees,i) => (
							<tr>
							<td class="txt-left"><input type="hidden" name={`fees_category_name_${i}`}  id={`fees_category_name_${this.state.extra_fees_id}_${i}_${this.state.index}`} value={fees.category_name} />{fees.category_name} </td>
							<td class="txt-center"><input type="hidden" name={`fees_amount_${i}`}  id={`fees_amount_${this.state.extra_fees_id}_${i}_${this.state.index}`} value={fees.amount} />{fees.amount}</td>
							<td class="txt-center"><input type="hidden" name={`paid_amount_${i}`}  id={`paid_amount_${this.state.extra_fees_id}_${i}_${this.state.index}`} value={fees.paid_amt}/>{fees.paid_amt}</td>		
							<td class="txt-center"><input type="hidden" name={`due_amount_${i}`}  id={`due_amount_${this.state.extra_fees_id}_${i}_${this.state.index}`} value={fees.due_amt} />{fees.due_amt}</td>
							<input type="hidden" name={`fees_id_${i}`}  id={`fees_id_${this.state.extra_fees_id}_${i}_${this.state.index}`} value={fees.id} />
							
			{(() => {
			if (fees.is_full_payment==false) {
				return (<>
				<td><div class="col col-md-12 s12 d-flex">
				<input type="number" step="any"  min="0"  max="100" name={`discount_per_${i}`}  id={`discount_per_${this.state.extra_fees_id}_${i}_${this.state.index}`}  onChange={this.discount_per_check.bind(this,i,this.state.index)} /></div></td>
								 
				<td><div class="col col-md-12 s12 d-flex"><input type="number" step="any" name={`discount_amt_${i}`} onChange={this.discount_check.bind(this,i,this.state.index)}  min="0" id={`discount_amt_${this.state.extra_fees_id}_${i}_${this.state.index}`} /></div></td>
								
				<td><div class="col col-md-12 s12 d-flex"><input  type="number" step="any" name={`payable_amt_${i}`} min="0" id={`payable_amt_${this.state.extra_fees_id}_${i}_${this.state.index}`} onChange={this.payable_amt_check.bind(this,i,this.state.index)} /></div></td>												
				<td>
				<div class="col col-md-12 s12 d-flex"> 
				<input type="date" defaultValue={this.state.currentDate} name={`enquiry_date_${i}`} id={`enquiry_date_${this.state.extra_fees_id}_${i}_${this.state.index}`} />
				</div>
				</td>
			</>)
			}
			else{
				return (<>
			<td>
				<input type="hidden" defaultValue={fees.discount_per}  name={`discount_per_${i}`}  id={`discount_per_${this.state.extra_fees_id}_${i}_${this.state.index}`} /> {fees.discount_per} 
			</td>
			<td>
				<input type="hidden" defaultValue={fees.discount_amt} name={`discount_amt_${i}`}  id={`discount_amt_${this.state.extra_fees_id}_${i}_${this.state.index}`} /> {fees.discount_amt} 
			</td>
			<td>
				<input type="hidden" name={`payable_amt_${i}`}  id={`payable_amt_${this.state.extra_fees_id}_${i}_${this.state.index}`} />
				<span class="text-green"><div class="chip chip-green"><div class="chip-body"><span class="chip-text"><i class="ri-check-line"></i> Paid</span></div></div></span>
			</td>
			<td><input type="hidden" defaultValue={fees.payable_date} name={`enquiry_date_${i}`}  id={`enquiry_date_${this.state.extra_fees_id}_${i}_${this.state.index}`}  />{fees.payable_date} </td>
				</>)
			}
		})()}	
				
								
							</tr>
							))}
						</tbody>
						
					</table>

					
					<table class="table white border-radius-4">	
						<tfoot>	
						<tr>
						<td colspan="8">
						<div class="col col-md-12 s12 text-center mt-10 mb-20">		
						{(() => {
							if (list.total_due>0) {
								return (
									<>
										<Button className="snd-btn" onClick={this.handleSubmitEnquiry.bind(this,this.state.index)} loading={this.state.loading}>Submit</Button>
									</>
								)
							}
						})()}	

						
						
						</div>
						</td>
						</tr>
						
						  <tr id="totLastRow">
							<td colspan="2">Total Amount : {list.total_amount}</td>   
							<td colspan="2">Total Discount : {list.total_discount}</td>  
							<td colspan="2">Total Paid Amount : {list.total_paid} </td>  
							<td colspan="2">Total Due Amount : {list.total_due}</td>  
						
							</tr>										
						</tfoot>
					</table>	
						
				
			  
				
	
				
				</div>
				))}
				
				</Modal>
			   
			   
			
			
			</>
		) 
	} 
}
export default Index;
